import { List, ListItem } from "@mui/material";
import PhoneIcon from "@mui/icons-material/Phone";
import CakeIcon from "@mui/icons-material/Cake";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import FlagIcon from "@mui/icons-material/Flag";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import GitHubIcon from "@mui/icons-material/GitHub";
import Paper from "@mui/material/Paper";
import { useHistory } from "react-router-dom";
import { Routes } from "../../types/Routes";
// @ts-ignore: Allow importing CSS side-effect without type declarations
import "../../styles/MissingInformationTile.css";
import icon from "../../img/icons/time_off.svg";
import OpsPanel from "../OpsPanel";

export const EnumTile = {
  Birthday: { text: "Birthday", icon: <CakeIcon /> },
  Phone: { text: "Phone", icon: <PhoneIcon /> },
  "Slack user ID": { text: "Slack user ID", icon: <AccountBoxIcon /> },
  "Github Username": { text: "Github Username", icon: <GitHubIcon /> },
  Avatar: { text: "Avatar", icon: <PhotoCameraIcon /> },
  Country: { text: "Country", icon: <FlagIcon /> },
} as const;

interface Props {
  rows: string[];
}

export default function MissingInformationTile({ rows }: Props) {
  const history = useHistory();

  return rows.length > 0 ? (
    <OpsPanel title="Missing Information" icon={icon} actionsRequired={false}>
      <Paper elevation={0} style={{ minHeight: "15.5em", maxHeight: "15.5em", overflow: "auto" }}>
        <List disablePadding>
          {rows.map((element: String) => {
            const key = element as keyof typeof EnumTile;
            return EnumTile[key] ? (
              <ListItem disableGutters key={key}>
                <span style={{ marginRight: 20 }}>{EnumTile[key]?.icon}</span>
                <span className="linkHover" onClick={() => history.push(Routes.PROFILE)}>
                  {EnumTile[key]?.text}
                </span>
              </ListItem>
            ) : null;
          })}
        </List>
      </Paper>
    </OpsPanel>
  ) : null;
}
